<template>


  <div class="d-flex mt-1 flex-wrap flex-md-nowrap justify-content-center">
    <div class="sale-left-container flex-fill mt-3">
      <div class="container-fluid px-0 pt-1">
        <b-row>
          <b-col cols="6">
            <div
              :class="['sale-left-header-button text-center align-content-center mr-0', { 'active': activeTab === 'quick' }]"
              @click="activeTab = 'quick'">
              Hızlı Satış
            </div>
          </b-col>
          <b-col cols="6">
            <div
              :class="['sale-left-header-button text-center align-content-center ml-0', { 'active': activeTab === 'package' }]"
              @click="activeTab = 'package'">
              Paket Satış
            </div>
          </b-col>
        </b-row>

        <!-- HIZLI SATIS -->
        <div v-if="activeTab === 'quick'"
          class="d-flex mt-4 justify-content-start align-items-center gap-3 flex-wrap px-3">
          <div v-for="service in services" :key="service.id"
            @click="addToBasket({ 'service': service, 'type': 'fast' })" class="sale-card position-relative">
            <img :src="service.images[0].url" v-if="service.images[0]" class="position-absolute left-0 top-0 right-0"
              style="height: 80px; justify-self: center;" :alt="service.name">
            <img src="/images/logo.png" v-else class="position-absolute left-0 top-1 right-0"
              style="height: 70px; justify-self: center;" alt="Lezzet Döner">
            <div class="sale-card-body bg-white h-100 w-100">
              <div class="sale-card-title fw-bold">{{ truncateName(service.name) }}</div>
              <div class="sale-card-alt-title">
                <span class="fw-bold" style="color: #686868 !important;">{{ service.measure }}</span> / {{
                  service.amount }}
              </div>
              <div class="sale-card-button">₺ {{ formatCurrency(service.price) }}</div>
            </div>
          </div>
        </div>

        <!-- PAKET SATIS -->
        <div v-else class="d-flex mt-4 justify-content-start align-items-center gap-3 flex-wrap px-3">
          <div v-for="service in services" :key="service.id" class="sale-card position-relative"
            @click="addToBasket({ 'service': service, 'type': 'package' })">
            <img :src="service.images[0].url" v-if="service.images[0]" class="position-absolute left-0 top-0 right-0"
              style="height: 80px; justify-self: center;" :alt="service.name">
            <img src="/images/logo.png" v-else class="position-absolute left-0 top-1 right-0"
              style="height: 70px; justify-self: center;" alt="Lezzet Döner">
            <div class="sale-card-body bg-white h-100 w-100">
              <div class="sale-card-title fw-bold">{{ truncateName(service.name) }}</div>
              <div class="sale-card-alt-title">
                <span class="fw-bold" style="color: #686868 !important;">{{ service.measure }}</span> / {{
                  service.amount }}
              </div>
              <div class="sale-card-button">₺ {{ formatCurrency(service.package_price) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sale-right-container mt-lg-0 mt-3">
      <div class="container-fluid sale-right-container-alt px-0 d-flex flex-column">
        <div class="d-flex justify-content-between px-2">
          <div class="sale-right-header-title">SİPARİŞ#</div>
          <div class="sale-right-header-title">#{{ orderId }}</div>
        </div>
        <div class="sale-right-header-alt d-flex gap-5 mt-1 align-items-center">
          <div class="sale-right-header-alt-1 d-flex align-items-center" @click="clearBasket">
            <img src="/images/sale-trash.png" alt="Temizle">
            <div class="ml-1">Temizle</div>
          </div>
          <div class="sale-right-header-alt-2">Toplam ({{ totalQuantity }})</div>
        </div>
        <div class="sale-right-basket-container flex-grow-1">
          <div class="sale-right-basket-container px-1 flex-grow-1">
            <div v-for="item in selectedItems" :key="`${item.id}-${item.type}`"
              class="sale-right-basket-item d-flex align-items-center">
              <div
                class="sale-right-basket-item-button-container d-flex flex-column align-items-center justify-content-center border ">
                <div class="sale-right-basket-item-button" @click="increaseQuantity(item)">
                  <img src="/images/plus-icon.png" alt="Arttır" style="width: 25px;">
                </div>
                <div class="sale-right-basket-item-counter d-flex align-items-center justify-content-center">{{
                  item.quantity }}</div>
                <div class="sale-right-basket-item-button" @click="decreaseQuantity(item)">
                  <img src="/images/vektor-icon.png" alt="Eksilt" style="width: 23px;">
                </div>
              </div>
              <div class="sale-right-basket-item-image mx-2 d-flex align-items-center justify-content-center">
                <img :src="item.images[0].url" v-if="item.images[0]" style="height: 50px;" :alt="item.name">
                <img src="/images/logo.png" v-else style="height: 40px;" alt="Lezzet Döner">
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="sale-right-basket-item-info-title" v-if="item.type === 'fast'">{{ item.name }}</div>
                <div class="sale-right-basket-item-info-title" v-if="item.type === 'package'">{{ item.name }} (Paket)
                </div>
                <div class="sale-right-basket-item-info-alt-title-2">
                  <span class="sale-right-basket-item-info-alt-title-1">{{ item.measure }}</span> / {{ item.amount
                  }}
                </div>
              </div>
              <div class="sale-right-basket-item-price ml-auto pr-1" v-if="item.type === 'fast'">₺{{
                formatCurrency(item.price *
                  item.quantity) }}</div>
              <div class="sale-right-basket-item-price ml-auto pr-1" v-if="item.type === 'package'">₺{{
                formatCurrency(item.package_price * item.quantity) }}</div>
            </div>
          </div>
        </div>
        <div class="sale-right-footer mx-2 mt-2 mb-3">
          <div class="container-fluid px-1">
            <div class="row mb-3">
              <div class="col-6 px-2">
                <div class="sale-right-footer-button " :class="{ 'selected': selectedButton === 'cash' }"
                  @click="selectButton('cash')">
                  <img class="mr-1" src="/images/sale-right-button-logo-1.svg" alt="">Nakit Satış
                </div>
              </div>
              <div class="col-6 px-2">
                <div class="sale-right-footer-button" :class="{ 'selected': selectedButton === 'card' }"
                  @click="selectButton('card')">
                  <img class="mr-1" src="/images/sale-right-button-logo-2.svg" alt="">Kart Satış
                </div>
              </div>
              <!--               <div class="col-4 px-2">
                <div class="sale-right-footer-button"><img class="mr-1" src="/images/sale-right-button-logo-3.svg"
                    alt="">Satış İptali</div>
              </div> -->
            </div>
            <div class="sale-right-footer-result">
              <!--   <div class="d-flex justify-content-between mx-3">
                <div class="sale-right-footer-result-title">Genel Toplam</div>
                <div class="sale-right-footer-result-price"></div>
              </div>
              <div class="d-flex justify-content-between mx-3">
                <div class="sale-right-footer-result-title">Servis Ücreti</div>
                <div class="sale-right-footer-result-price"></div>
              </div> -->
              <div class="d-flex justify-content-between mx-3 mt-2">
                <div class="sale-right-footer-result-title" style="color: #2B2930 !important;">TOPLAM</div>
                <div class="sale-right-footer-result-price" style="color: #2B2930 !important;">{{
                  formatCurrency(totalPrice) }} ₺</div>
              </div>
            </div>
            <div class="sale-right-footer-result-button" @click="submitSale">ÖDEME YAP</div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="contractModal">
      <div class="d-flex justify-content-center">
        <b-button variant="success" @click="downloadOrderContract">Fiş Oluştur</b-button>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="$refs.contractModal.hide()">{{ $t("Kapat") }}</b-button>
      </template>
    </b-modal>
  </div>

</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      activeTab: 'quick',
      services: [],
      selectedItems: [],
      selectedButton: 'cash',
      orderId: "0",
      soldService: null,
      soldSales: null,
    }
  },
  methods: {
    ...mapActions([
      'getSaleServices',
      'postSale',
      'getLastProcess'
    ]),
    truncateName(name) {
      if (name.length > 15) {
        return name.substring(0, 15) + '...';
      }
      return name;
    },
    getItems() {
      return this.getSaleServices()
        .then(data => data.data).then(response => {
          this.services = response.services;
        })
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    addToBasket(values) {
      let product = values.service;
      let type = values.type;

      const existingItem = this.selectedItems.find(item => (item.id === product.id && item.type === type));
      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        this.selectedItems.push({ ...product, quantity: 1, type: type });
      }
    },
    clearBasket() {
      this.selectedItems = [];
    },
    increaseQuantity(item) {
      item.quantity += 1;
    },
    decreaseQuantity(item) {
      if (item.quantity > 1) {
        item.quantity -= 1;
      } else {
        this.selectedItems = this.selectedItems.filter(i => i.id !== item.id);
      }
    },
    downloadOrderContract() {
      this.downloadContract(this.soldService, this.soldSales);
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    downloadContract(service, sales) {
      const WinPrint = window.open('', '', 'left=0,top=0,width=1000,height=400,toolbar=0,scrollbars=0,status=0');
      let itemsHtml = sales.map(item => `
        <tr>
          <td style="font-size: 11px;">${item.type === 'package' ? item.name + ' (Paket)' : item.name}</td>
          <td style="font-size: 11px;">${item.quantity}</td>
          <td style="font-size: 11px;white-space: nowrap;">${item.type === 'package' ? this.formatCurrency(item.package_price * item.quantity) : this.formatCurrency(item.price * item.quantity)} ₺</td>
        </tr>
      `).join('');

      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <style>
              body {
                font-family: 'Courier New', Courier, monospace;
                width: 300px;
                margin: 0 auto;
                text-align: left;
              }
              h2 {
                text-align: center;
              }
              .line {
                border-bottom: 1px dashed #000;
                margin: 10px 0;
              }
              table {
                width: 100%;
                border-collapse: collapse;
              }
              td {
                padding: 5px;
              }
              .total {
                text-align: right;
                font-weight: bold;
              }
              .adisyon-nakit{
                display: flex;
                justify-content: space-between;
                align-items: center;
              }
              .logo-container{
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 20px;
              }
            </style>
          </head>
          <body>
            <div class="logo-container">
              <img id="logo" src="/images/logo.png" alt="Lezzet Döner" style="height: 120px;">
            </div>
            <p style="font-size: 12px; margin-bottom: 1px;">Tarih: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}</p>
            <div class="adisyon-nakit" style="margin-top: 1px;">
              <p style="font-size: 12px;">Adisyon No: #${this.orderId}</p>
              <p style="font-size: 12px;">${this.selectedButton === 'cash' ? 'Nakit' : 'Kart'}</p>
            </div>
            
            <div class="line"></div>
            <table>
              <tr>
                <th style="font-size: 11px;">Ürün Adı</th>
                <th style="font-size: 11px;">Adet</th>
                <th style="font-size: 11px;">T. Tutar</th>
              </tr>
              ${itemsHtml}
            </table>
            <div class="line"></div>
            <p class="total" style="font-size: 12px;">Genel Toplam: ${this.formatCurrency(service.price)} ₺</p>
            <p style="font-size: 10px; margin-top: 20px;">***Adisyon çıktısıdır. Mali Fiş/Fatura yerine geçmez</p>
          </body>
        </html>`);

      const logo = WinPrint.document.getElementById('logo');
      logo.onload = function () {
        WinPrint.focus();
        WinPrint.print();
        setTimeout(() => {
          WinPrint.close();
          window.location.reload();
        }, 2000);
      };
    },
    submitSale() {
      if (this.selectedItems.length === 0) {
        this.$swal({
          icon: 'info',
          title: 'Dikkat',
          text: 'Satış sepeti boş',
          showCancelButton: false,
          confirmButtonText: 'Tamam'
        })
      } else {
        this.postSale({ items: this.selectedItems, payment_type: this.selectedButton })
          .then((response) => {
            this.success(response.data.message);
            this.soldService = response.data.service;
            this.soldSales = response.data.sales;
            this.downloadContract(this.soldService, this.soldSales);
          })
          .catch((error) => {
            this.format(error.response.data.errors).forEach((item) => {
              this.error(item);
            });
          });
      }
    },
    selectButton(button) {
      this.selectedButton = button;
    },
    lastProcess() {
      return this.getLastProcess()
        .then(data => data.data).then(response => {
          this.orderId = response ? response.id + 1 : "0";
        })
    }
  },
  computed: {
    totalQuantity() {
      // Toplam miktarı hesapla
      return this.selectedItems.reduce((total, item) => total + item.quantity, 0);
    },
    totalPrice() {
      return this.selectedItems.reduce((total, item) => {
        const price = item.type === 'package' ? item.package_price : item.price;
        return total + (price * item.quantity);
      }, 0);
    },

  },
  mounted() {
    this.getItems();
    this.lastProcess();
  }
}
</script>

<style scoped>
.user-background {
  background-color: #F0F0F3 !important;
  height: 100%;
}

.user-container {
  max-width: 1024px;
  margin: 0 auto;

  font-family: 'Roboto', sans-serif !important;
}

.gap-3 {
  gap: 12px;
}

.gap-4 {
  gap: 16px;
}

.navbar-collapse {
  background-color: #F0F0F3 !important;
}

.user-navbar {
  background-color: #F0F0F3 !important;
}

.navbar-light .navbar-nav .nav-link {
  font-size: 18px !important;
  font-weight: 500 !important;
  color: #797676 !important;
  border-radius: 10px !important;
  box-shadow:
    -2.18px -2.18px 6.54px rgba(255, 255, 255, 1),
    2.18px 2.18px 6.54px rgba(174, 174, 205, 0.4) !important;
  margin: 0 12px !important;
  transition: all 0.3s ease !important;
  align-content: center !important;
  width: 155px;
}

.navbar-light .navbar-nav .nav-link:hover {
  color: #D0C4C4 !important;
  background-color: #0C6D01 !important;
}

.navbar-light .navbar-nav .nav-link:active {
  color: #D0C4C4 !important;
  background-color: #0C6D01 !important;
}

.navbar-light .navbar-nav .nav-link:focus {
  color: #D0C4C4 !important;
  background-color: #0C6D01 !important;
}

.navbar-light .navbar-nav .nav-link.active {
  color: #D0C4C4 !important;
  background-color: #0C6D01 !important;
}

.sale-left-container {
  height: 730px;
  background-color: #F0F0F3;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 50px;
}



.sale-left-header-button {
  font-size: 18px;
  font-weight: 500;
  color: #797676;
  height: 50px !important;
  border-radius: 10px;
  box-shadow:
    -2.18px -2.18px 6.54px rgba(255, 255, 255, 1),
    2.18px 2.18px 6.54px rgba(174, 174, 205, 0.4);
  margin: 0 12px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.sale-left-header-button:hover {
  background-color: #0C6D01;
  color: #FFFFFF;
}

.sale-left-header-button.active {
  background-color: #0C6D01;
  color: #FFFFFF;
}

.sale-card {
  width: 122px;
  height: 178px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sale-card:hover {
  scale: 1.05;
}

.sale-card-body {
  margin-top: 36px;
  height: 152px;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  padding-bottom: 7px;
  border-radius: 25px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  background-color: white !important;
}

.sale-card-title {
  font-size: 12px;
  font-weight: 500;
  color: #000000;
  text-align: center;
  line-height: 1;
}

.sale-card-alt-title {
  font-size: 12px;
  font-weight: 400;
  color: #ACACAC;
  border-bottom: 1px solid #acacac44;
  width: 106px;
  text-align: center;
}

.sale-card-button {
  width: 106px;
  height: 26px;
  background-color: #0C6D01;
  border-radius: 17px;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sale-card-button:hover {
  background-color: #0f9b00;
}

.sale-right-container {
  padding: 0 6px;
  min-width: 283px !important;
  max-width: 283px !important;
  min-height: 730px !important;
}

.sale-right-container-alt {
  box-shadow:
    -2.18px -2.18px 6.54px rgba(255, 255, 255, 1),
    2.18px 2.18px 6.54px rgba(174, 174, 205, 0.4);
  height: 100%;
  border-radius: 10px;
  padding-top: 13px;
}

.sale-right-header-title {
  font-size: 16px;
  font-weight: 600;
  color: #01472D;
}

.sale-right-header-alt {
  background-color: #E6EDEA;
  padding: 5px 10px;
}

.sale-right-header-alt-1 {
  font-size: 12px;
  font-weight: 400;
  color: #01472D;
  cursor: pointer;
}

.sale-right-header-alt-2 {
  font-size: 14px;
  font-weight: 600;
  color: #01472D;
  margin-left: 80px;
}

.sale-right-basket-item {
  background-color: #E6EDEA;
  color: #FFFFFF;
  border-radius: 10px;
  padding: 2px 5px;
  margin-top: 8px;
  height: 76px;
}

.sale-right-basket-item-button-container {
  width: 38px;
  border-radius: 20px;
}

.sale-right-basket-item-button {
  font-size: 18px;
  color: #4A5C2F;
  cursor: pointer;

}

.sale-right-basket-item-counter {
  background-color: #01472D;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #FFFFFF;
}

.sale-right-basket-item-info-title {
  font-size: 12px;
  font-weight: 600;
  color: #01472D;
}

.sale-right-basket-item-info-alt-title-1 {
  font-size: 12px;
  font-weight: 500;
  color: #686868;
}

.sale-right-basket-item-info-alt-title-2 {
  font-size: 12px;
  font-weight: 500;
  color: #ACACAC;
}

.sale-right-basket-item-price {
  font-size: 14px;
  font-weight: 700;
  color: #01472D;
}

.sale-right-footer-button {
  box-shadow:
    -2.18px -2.18px 6.54px rgba(255, 255, 255, 1),
    2.18px 2.18px 6.54px rgba(174, 174, 205, 0.4);
  padding: 10px 0;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #01472D;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sale-right-footer-button:hover {
  background-color: #0C6D01;
  color: #FFFFFF;
}

.sale-right-footer-button:hover svg {
  fill: #fff !important;
}

.sale-right-footer-result-title {
  font-size: 14px;
  font-weight: 500;
  color: #797676;
}

.sale-right-footer-result-price {
  font-size: 18px;
  font-weight: 500;
  color: #313030;
}

.sale-right-footer-result {
  border-top: 1px dashed #AEAEB2;
  border-bottom: 1px dashed #AEAEB2;
  padding: 10px 0;
}

.sale-right-footer-result-button {
  border-radius: 10px;
  background-color: #0C6D01;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 500;
  padding: 12px 0;
  text-align: center;
  cursor: pointer;
  margin-top: 14px;
  transition: all 0.3s ease;
}

.sale-right-footer-result-button:hover {
  background-color: #0f9b00;
}


.sale-right-basket-container {
  height: 430px;
  overflow-y: auto;
}

.nav-link {
  height: 45px
}

.navbar-collapse {
  background-color: #F0F0F3 !important;
  position: relative;
}

.sale-right-footer-button.selected {
  background-color: #0C6D01;
  color: white;
}
</style>